import { render, staticRenderFns } from "./WorkLinkouts.vue?vue&type=template&id=cc2888b8&scoped=true"
import script from "./WorkLinkouts.vue?vue&type=script&lang=js"
export * from "./WorkLinkouts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc2888b8",
  null
  
)

export default component.exports